import { render, staticRenderFns } from "./LicenseOverviewAlpha.vue?vue&type=template&id=27f0a6e0"
import script from "./LicenseOverviewAlpha.vue?vue&type=script&lang=js"
export * from "./LicenseOverviewAlpha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports